import { adminAPIService } from './index'

const route = 'featured'

export const getFeaturedItems = () => adminAPIService({
  url: `${route}`,
  method: 'get',
})

export const getFeaturedItemDetail = (type, platform) => adminAPIService({
  url: `${route}/type/${type}/platform/${platform}`,
  method: 'get',
})

export const updateFeaturedItem = (featured, type, platform) => {
  const body = `json=${encodeURIComponent(JSON.stringify(featured))}`
  return adminAPIService({
    url: `${route}/type/${type}/platform/${platform}`,
    method: 'post',
    data: body,
  })
}
